import React from 'react';

export const GovernmentProgramsSection = () => {
  const programs = [
    {
      id: "local-gov",
      title: "Local Government Infrastructure Programs",
      description: "Supporting councils with planning and delivery of capital works programs"
    },
    {
      id: "drfa",
      title: "Disaster Recovery Funding Arrangements (DRFA)",
      description: "Expert management of DRFA projects including funding compliance and reporting"
    },
    {
      id: "transport",
      title: "Transport Infrastructure Upgrades",
      description: "Road and transport infrastructure improvement projects"
    },
    {
      id: "environmental",
      title: "Environmental Remediation Projects",
      description: "Contamination management and environmental restoration works"
    },
    {
      id: "waste",
      title: "Waste Infrastructure Development",
      description: "Landfill development, processing facilities and waste management infrastructure"
    },
    {
      id: "capital-works",
      title: "Large-Scale Capital Works Programs",
      description: "Program management support for major multi-project infrastructure initiatives"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Specialist Experience in Local Government Capital Works Programs
          </h2>
          <div className="w-24 h-1 bg-blue-900 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {programs.map((program) => (
            <div 
              key={program.id}
              className="group relative bg-white p-8 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden"
            >
              <div className="relative z-10">
                {/* Blue accent bar on left */}
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-blue-900 via-blue-800 to-blue-900 transform origin-left scale-x-100 group-hover:scale-x-150 transition-transform duration-500"></div>
                
                <div className="pl-6">
                  <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-blue-900 transition-colors duration-300">
                    {program.title}
                  </h3>
                  <p className="text-slate-600">
                    {program.description}
                  </p>
                </div>
              </div>

              {/* Bottom accent line */}
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-900 to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
